module.exports = __webpack_public_path__ + "static/media/pl_8_online.6ca05be3.png";